import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import { MdAdd } from "react-icons/md";
import Pill from "./pill";

export default function Text({ value, onChange, params, sources }) {
  const [_value, setValue] = useState(["edit me..."]);
  const [focusInput, setFocusInput] = useState(0);

  useEffect(() => {
    if (Array.isArray(value) && (value[0] || value[0] === "")) {
      setValue(value);
    } else {
      setValue(["edit me..."]);
    }
  }, [value]);

  const handleTextChange = (v, index) => {
    console.log(v);
    const value = [..._value];
    value[index] = !!v ? v : "";
    setValue(value);
    setFocusInput(value.length - 1);
    onChange(value);
  };

  const handleAddData = (e) => {
    e.preventDefault();
    const value = [..._value];
    value.splice(focusInput + 1, 0, {});
    if (focusInput === _value.length - 1) {
      value.push("");
    }
    setValue(value);
  };

  const handleDelete = (i) => {
    const newValue = [..._value];

    newValue.splice(i, 1);

    const _newvalue = [];
    newValue.forEach((x, i, arr) => {
      if (typeof x === "string" && typeof arr[i + 1] === "string") {
        _newvalue.push(x + arr[i + 1]);
      } else if (typeof x === "string" && typeof arr[i - 1] === "string") {
      } else {
        _newvalue.push(x);
      }
    });
    setValue(_newvalue);
    onChange(_newvalue);
  };
  return (
    <div style={{ position: "relative" }}>
      <div className={styles.text}>
        {_value.map((v, index) => {
          if (typeof v === "string") {
            return (
              <span
                className={
                  !v
                    ? styles.textInput + " " + styles.emptyText
                    : styles.textInput
                }
                onBlur={(e) => handleTextChange(e.target.innerText, index)}
                onFocus={() => setFocusInput(index)}
                key={v + index}
                dangerouslySetInnerHTML={{
                  __html: v.replace(/(?:\r\n|\r|\n)/g, "<br>"),
                }}
                role="textbox"
                contentEditable
              />
            );
          }

          return (
            <Pill
              value={v}
              type="Text"
              list={false}
              sources={sources}
              onChange={(v) => handleTextChange(v, index)}
              onDelete={() => handleDelete(index)}
              key={index}
            />
          );
        })}
      </div>
      <MdAdd
        onMouseDown={(e) => e.preventDefault()}
        onClick={handleAddData}
        className={styles.add}
      />
    </div>
  );
}
